/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import Fieldset from "../Fieldset";
import FieldsetProps from "../Fieldset/FieldsetProps";
import "./DialogContentFieldset.scss";

export default function DialogContentFieldset({ className, tooltip, ...restProps }: FieldsetProps) {
    return (
        <Fieldset
            className={`lan-dialogcontentfieldset ${className ?? ""}`.trim()}
            tooltip={tooltip}
            {...restProps}
        />
    );
}
